import { render, staticRenderFns } from "./scrollLoader.vue?vue&type=template&id=2dd75ea0&scoped=true&"
import script from "./scrollLoader.vue?vue&type=script&lang=js&"
export * from "./scrollLoader.vue?vue&type=script&lang=js&"
import style0 from "./scrollLoader.vue?vue&type=style&index=0&id=2dd75ea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd75ea0",
  null
  
)

export default component.exports